// Must match the backend Channels.cs. Segments allow [A-Za-z0-9-] only (AppSync rejects
// underscores), so free-text customer ids are sanitised identically on both sides.
const safe = (segment) => String(segment).replace(/[^A-Za-z0-9-]/g, "-");

export const channels = {
  user: (merchantId, userId) => `merchant/${merchantId}/user/${userId}`,
  customer: (merchantId, customerId) => `merchant/${merchantId}/customer/${safe(customerId)}`,
  // Merchant-wide activity across all customers (the Today's-tasks activity feed).
  merchantActivity: (merchantId) => `merchant/${safe(merchantId)}/activity`,
};
